// Selectors and variables
var wsAddtocartForm = [
  "#shopify-section-product-template form[action$='/cart/add']",
  "form.product-purchase-form[action^='/cart/add']",  
  "form.shopify-product-form[action^='/nl/cart/add']",
  "form.shopify-product-form[action^='/fr/cart/add']",
  "form.shopify-product-form[action^='/de/cart/add']",
  "form.shopify-product-form[action^='/cart/add']",
  ".product-form form[action$='/cart/add.js']",
  ".product-form form[action$='/cart/add']"
].join(', ');


var addToWishlistCollection = '.cs_ws_icon';
var addToWishlistProduct = '#ws-fav-html';
var wsAddtocartBtn = "button[name='add'], input[name='add'], [name='add']";
var wsAddtocartBtnClass = "btn btn1 pr_btn btn--full btn--secondary w-full button button--primary button--filled button--large button--primary__filled _button--secondary _button--primary action_button button--full-width";
var wsBtnID = "ws-fav-html";
var wsBtnText = "Add to Wishlist";
var wsBtnTextWishlist = "In Wishlist";
var icon = window.wsapps.wishlist_icon;
var fillicon = window.wsapps.wishlist_icon_fill;
var latestCategories = '';
var ajaxcustomer_id = window.wsapps.customerId;
var ajaxcustomer_name = window.wsapps.customerName;
var ajaxcustomer_email = window.wsapps.customerEmailId;
var pageUrl = `/pages/${window.wsapps.pageURL}`;
if(window.wsapps.wishlist_status == '1') { 
  function setLoader() {
    //console.log('setLoader ======================================================');
    var CSWishlistPage = document.getElementsByClassName("CS-Wishlist-page");
    if(CSWishlistPage.length > 0){
      for (var i = 0; i < CSWishlistPage.length; i++) {
        CSWishlistPage[i].innerHTML = '<div class="EmptyPageData"><img src="https://cdn.shopify.com/s/files/1/0610/9642/7715/files/Web.gif?v=1709644593" /></div>';
      }
    }
  }
  function removeLoader() {
    //console.log('removeLoader ======================================================');
    $("#CS-Wishlist-page .EmptyPageData").remove();
  }
  // Get the current URL
  var currentURL = window.location.href;
  function wishlistHTML(data){
    //console.log('wishlistHTML ======================================================');
    var wishlistHTML = document.getElementsByClassName('CS-Wishlist-page');
    if(wishlistHTML.length > 0){
      for (var i = 0; i < wishlistHTML.length; i++) {        
        wishlistHTML[i].innerHTML = '';  
        wishlistHTML[i].innerHTML += data;
      }
    }
  }
  
  function getUrlParameter(name) {
    // console.log('getUrlParameter ======================================================');
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(currentURL);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }    
  
  // Extract values for from_user_id and list_id
  var fromUserId = getUrlParameter('from_user_id');
  var listId = getUrlParameter('list_id');
  
  function CSCategoryGetSingle(catId) {  
    //console.log('CSCategoryGetSingle ====================================================== API');    
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = fromUserId;    
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/category/${catId}?store_name=${window.wsapps.store_name}`;  
    
    fetch(url)
    .then(response => {        
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {
      if (result && typeof result.data === 'object' && result.data !== null) {        
        var productList = [];                   
        for (var i = result.data.products.length - 1; i >= 0; i--) {
            var product = result.data.products[i];
            product["cid"] = result.data.id;
            productList["title"] = result.data.category_name;
            productList.push(product);
        }
        if(productList.length > 0){
          CSRetrieveWsDataCategoryShow(productList, 'drawer', catId)
          if(listId){
            //console.log('15 =================');
            CSRetrieveWishlistData('drawer');    
          }
        }else{
          window.location.href = "/pages/"+window.wsapps.pageURL;
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
  
  /* Wishlist Retrieve Wishlist Data */      
  function CSRetrieveWsDataCategory(catId) {  
    //console.log('CSRetrieveWsDataCategory ======================================================  API');
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = fromUserId ? fromUserId : ajaxcustomer_id;   

    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;  
    
    fetch(url)
    .then(response => {        
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {      
      // Check if result.data exists and is an object
      if (result && typeof result.data === 'object' && result.data !== null && Array.isArray(result.data.categories)) {        
        var productList = []
        for (const obj of result.data.categories) {
          if (obj.id == listId && listId) {            
            for (var product of obj.products) {
              product["cid"] = obj.id;
              productList["title"] = obj.category_name;
              productList.push(product);
            }
          }          
        } 
        if(listId){
          if(productList.length > 0){            
            CSRetrieveWsDataCategoryShow(productList)
          }else{
            window.location.href = "/pages/"+window.wsapps.pageURL;
          }
        }      
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
  // Category Header
  function CScategoryHeader(key){    
    //console.log('CScategoryHeader ======================================================');
    var CScategoryHeader = `<div class="cs-list-header-title"><h4>${key.toLowerCase()}</h4></div>`;      
    return CScategoryHeader
  }

  
  // Particular category in detail
  async function CSRetrieveWsDataCategoryShow(productList, drawer, catId) { 
    //console.log('CSRetrieveWsDataCategoryShow ======================================================');
    var htmlNew = `<div class="button_back"><a href="/pages/${window.wsapps.pageURL}"></a><div class="productListtitle">${productList.title.toLowerCase()}</div></div><div class="productHandlesByCategory productHandlesByCategory-134 productHandlesByCategory-${catId} category-id-${productList.title.toLowerCase()}" data-name="${productList.title.toLowerCase()}" id="category-id-Seci" data-cat-id="${catId}">`;
    htmlNew += `<div class="category-list-wrapper"><div class="category-list ${window.wsapps.parentClass}">`;
    productList.slice().forEach(product => {
      htmlNew += `
      <div class="111 = cross-sell-product-item-drawer cross-sell-product-item cross-sell-item main-product-item two_column_item" data-handle="${product.handle}" data-id="${product.variants.shopify_variant_id}">
       <div class="cross-sell-product-image">
          <a href="/products/${product.handle}">
            <img src="${product.image_url}" alt="${product.title}" loading="lazy">
          </a>
       </div>
       <div class="cross-sell-product-content">
          <div class="cross-sell-product-price">
             <div class="cs-product-title">
                <a href="${product.handle}">${product.title}</a>
             </div>
             <div class="cs_ws_icon" data-id="${product.shopify_product_id}" data-handle="${product.handle}" data-varid="${product.variants.shopify_variant_id}">
                <button aria-label="Add to Wishlist" id="ws-fav-btn" type="button" class="action_button  ws-active">
                   <span class="cs-wishlist-icon">
                      <svg width="25" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M11.5801 0.992188L14.668 7.2511L21.5801 8.2606L16.5801 13.13L17.7678 20.0183L11.5801 16.7642L5.39243 20.0183L6.58008 13.13L1.58008 8.2606L8.49219 7.2511L11.5801 0.992188Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                   </span>
                </button>
             </div>
          </div>          
       </div>
    </div>`;      
    })
    
    htmlNew += '</div></div></div>';    
    if(drawer){
      var wishlistHTML1 = document.querySelectorAll('.main-wrapper .CS-Wishlist-page'); 
      wishlistHTML1.forEach(function(element) {
        element.innerHTML = '';  
        element.innerHTML += htmlNew; 
      });
    }else{
      wishlistHTML(htmlNew)
    }
    if(location.pathname.includes('/collections/')){ 
      wishlistBtnCollection(productList);
    }
    formData();
    
  }

  
  function CSRetrieveWishlistProData() {
    //console.log('CSRetrieveWishlistProData ====================================================== API');
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = window.wsapps.customerId;
    wsGetWishlist.product_id = window.wsapps.product_id;
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlists-by-product?${params1.toString()}`;  
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {
      // console.log('result ===', result);
      // console.log('result ===', result.data.isWishlistHasProduct);
      var csWsIconPro = document.querySelector(addToWishlistProduct);
      let spanbutton = csWsIconPro.querySelector('button');
      if(result.data.isWishlistHasProduct){
        csWsIconPro.setAttribute('data-categoryId', result.data.categoryIds[0]);  
        csWsIconPro.setAttribute('data-varId-dddd', 'window.wsapps.variant_id');
        csWsIconPro.setAttribute('data-varId', window.wsapps.variant_id);
        csWsIconPro.setAttribute('data-handle', window.wsapps.product_handle);
        //csWsIconPro.setAttribute('data-categoryId', matchedProduct.cid);   
        if (spanbutton) {
          spanbutton.classList.add('ws-active');
        }
        let span = csWsIconPro.querySelector('span');
        if (span) {
          span.innerHTML = fillicon;
        }
      }else{
         csWsIconPro.classList.remove('ws-active');
      }  
      //console.log('1 =================');
      CSRetrieveWishlistData('drawer');
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  

  
  /* Wishlist Retrieve Wishlist Data */      
  function CSRetrieveWishlistData(drawer, customer_id) { 
    //console.log('CSRetrieveWishlistData ====================================================== Main function Disha  API');
    $('div.productHandlesByCategory').hide()
    // $('.cs-wishlist-wrapper').html('')
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = customer_id ? customer_id : ajaxcustomer_id;
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;  
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {
      $('div.productHandlesByCategory').show()
      if (result && typeof result.data === 'object' && result.data !== null && Array.isArray(result.data.categories)) {
        var mainArray = result.data.categories; 
        if (Array.isArray(mainArray) && mainArray.length > 0) {
          latestCategories = mainArray[mainArray.length - 1].id; 
        }
        var productList = []
        for (const obj of mainArray) {          
          for (var product of obj.products) {
            product["cid"] = obj.id;
            productList.push(product)
          }
        } 
        if(drawer){
          CSWishlistDrawerData(result, productList);  
        }else{
          if(location.pathname.includes('/collections/')){            
            wishlistBtnCollection(productList);      
          }
          if(location.pathname.includes('/products/')){ 
            wishlistBtnPDP(productList);
          }
          if($('.main-wrapper .CS-Wishlist-page').length > 0){
            if(!listId){              
              CSWishlistPageData(result, productList);
              CSWishlistDrawerData(result, productList);  
            }else{              
              CSCategoryGetSingle(listId);
              CSWishlistDrawerData(result, productList);  
            }
          }
        }
        if(mainArray.length === 0){
          var productHandles = document.querySelector('.productHandlesByCategory[data-name="newCategory"]');      
          if (productHandles) {
              productHandles.style.display = 'none';
          }
        }
        //Get page data End        
      } else {
        if(location.pathname.includes('/products/')){ 
          wishlistBtnPDP();
        }
        wishlistBtnCollection();
        emptyPage();
        var wishlistHTML = document.querySelectorAll('.main-wrapper .CS-Wishlist-page');
        if(wishlistHTML.length > 0){
          for (var i = 0; i < wishlistHTML.length; i++) {
            wishlistHTML[i].classList.add("wishlist-overflow");
          }
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
 
  if(fromUserId){    
    CSCategoryGetSingle(listId)   
    if(location.pathname.includes('/collections/')){
      //console.log('2 =================');
      CSRetrieveWishlistData('drawer');
    }
  }else if(ajaxcustomer_id){     
    if(location.pathname.includes(pageUrl)){
      //console.log('3 =================');
      CSRetrieveWishlistData();
    } else if(location.pathname.includes('/collections/') && location.pathname.includes('/products/') || location.pathname.includes('/products/')){
       CSRetrieveWishlistProData()     
      //CSRetrieveWishlistData('drawer');    
    } else if(location.pathname.includes('/collections/')){   
      //console.log('4 =================');
      CSRetrieveWishlistData('drawer');    
    } else{
       $('.cart_tab_link2').click(function(){
        //console.log('5 =================');
        CSRetrieveWishlistData('drawer');
      })
    }
    
  }else{    
    if(location.pathname.includes('/products/')){ 
      wishlistBtnPDP()
    }
    if(location.pathname.includes('/collections/')){ 
      wishlistBtnCollection()
    }
    emptyPage();
  }

  function emptyPage() {    
    //console.log('emptyPage ======================================================');
    var data = CSWSPageDataHeader();   
    data += emptyhtmlGrid();
    wishlistHTML(data);
    var elements = document.querySelectorAll('button#csws-create-list');
    for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none';
    }
  }
  /* Fetch Wishlist data on button click */
  function CSUpdateUI(target, PDPButton, newCreate) { 
    //console.log('CSUpdateUI ======================================================  API');
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = ajaxcustomer_id;   
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;  
    fetch(url)
    .then(response => {        
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {    
      var mainArray = result.data.categories;        
      var productList = []
      for (const obj of mainArray) {          
        for (var product of obj.products) {
          product["cid"] = obj.id;
          productList.push(product);
        }
      }
      var CSWishlistPage = document.getElementsByClassName("CS-Wishlist-page");
      if(CSWishlistPage && listId && fromUserId){   
        CSRetrieveWsDataCategory();             
      }else if(CSWishlistPage && newCreate){
        CSWishlistPageData(result, productList);
        CSWishlistDrawerData(result, productList);
      }else{
        if(PDPButton){
          var active = typeof productList != 'undefined' && productList != null ? productList.find(item => item.handle === window.wsapps.product_handle) : active;          
          if (active) {            
            target.setAttribute('aria-label', wsBtnTextWishlist);
            target.closest('#'+wsBtnID).setAttribute('data-categoryId', active.cid);
            target.className = 'ws-active '+wsAddtocartBtnClass;
            target.querySelector('.cs-wishlist-text').textContent = wsBtnTextWishlist;
            target.querySelector('.cs-wishlist-icon').innerHTML = fillicon;
          }else{
            target.setAttribute('aria-label', wsBtnText);
            target.closest('#'+wsBtnID).setAttribute('data-categoryId', '');
            target.classList.remove('ws-active');
            target.querySelector('.cs-wishlist-text').textContent = wsBtnText;
            target.querySelector('.cs-wishlist-icon').innerHTML = icon;
          }
        }else{
          var dataHandle = target.closest(addToWishlistCollection).getAttribute('data-handle');   
          var active = typeof productList != 'undefined' && productList != null ? productList.find(item => item.handle === dataHandle) : active;            
          if(active){ 
            target.closest(addToWishlistCollection).setAttribute('data-categoryId', active.cid);        
            target.setAttribute('aria-label', wsBtnTextWishlist);                
            target.classList.add('ws-active');
            target.querySelector('span').innerHTML = fillicon;
          }else{
            target.setAttribute('aria-label', wsBtnText);                
            target.classList.remove('ws-active');
            target.querySelector('span').innerHTML = icon;
          }
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });    
  }
  
  /* Add Wishlist btn on Collection page */
  function wishlistBtnCollection(productData){  
    //console.log('wishlistBtnCollection ======================================================');
    var csWsIcon = document.querySelectorAll(addToWishlistCollection);
    csWsIcon.forEach(function(element) {
      let buttonInner = element.querySelector('button');
      let span = element.querySelector('span');
      var dataHandle = element.getAttribute('data-handle');
      var matchedProduct = Array.isArray(productData)
        ? productData.find(item => item.handle === dataHandle)
        : null;
      
      if (matchedProduct) {
        element.setAttribute('data-categoryId', matchedProduct.cid);
        element.setAttribute('aria-label', wsBtnTextWishlist);
        if (buttonInner) {
          buttonInner.classList.add('ws-active', 'action_button', 'DishaMavani');
        }        
        if (span) {
          span.innerHTML = fillicon;
        }
      } else {
        if (buttonInner) {
          buttonInner.classList.remove('ws-active', 'action_button', 'DishaMavani');
        }
        if (span) {
          span.innerHTML = icon;
        }
      }
    });    
  }

  /* Add Wishlist btn on PDP page */
  function wishlistBtnPDP(productData) {
    // console.log('wishlistBtnPDP ======================================================');    
    var csWsIconPro = document.querySelectorAll(addToWishlistProduct);
    csWsIconPro.forEach(function(element) {
      let span = element.querySelector('span');
      let spanbutton = element.querySelector('button');
      var matchedProduct = Array.isArray(productData)
        ? productData.find(item => item.handle === window.wsapps.product_handle)
        : null;
      if (matchedProduct) {
        element.setAttribute('data-varId', window.wsapps.variant_id);
        element.setAttribute('data-handle', window.wsapps.product_handle);
        element.setAttribute('data-categoryId', matchedProduct.cid);        
        if (spanbutton) {
          spanbutton.classList.add('ws-active');
        }
        if (span) {
          span.innerHTML = fillicon;
        }
      } else {
        if (spanbutton) {
          spanbutton.classList.remove('ws-active');
        }
        if (span) {
          span.innerHTML = icon;
        }
      }
    });
  }
  async function categoryGetList(target, productHandle, data_id, variant_id, category_id, customer_id, customer_name, customer_email) {
    //console.log('categoryGetList ======================================================  API');    
    var button = target.querySelector('#ws-fav-btn');
    if (button.classList.contains('ws-active')) {
        btnClick(target, productHandle, data_id, variant_id, category_id)
    } else {        
        var wsGetWishlist = {};
        wsGetWishlist.store_name = window.wsapps.store_name;
        wsGetWishlist.customer_id = customer_id ? customer_id : ajaxcustomer_id;
        let params1 = new URLSearchParams(wsGetWishlist);
        let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(result => {
                document.querySelector('.cart_tab2 #CS-Wishlist-page').style.display = 'flex';
                if (result.data) {
                    if (result.data.categories.length > 1) {
                        $('.header .cart a').trigger('click');
                        $('.cart_tab_link2').trigger('click');
                        if (customer_id) {                          
                           // $('.cart_tab2').html('<div id="CS-Wishlist-page" class="EmptyPageLoader CS-Wishlist-page CS-drawer-wishlist main-collection-section"><div class="EmptyPageData"><img src="https://cdn.shopify.com/s/files/1/0630/4261/7558/files/effiel_new.gif?v=1728881762" /></div></div>');
                        }
                        $('.cart_tab2 #CS-Wishlist-page').addClass('selectCategory');
                        $('body').off('click', '.ws-pro-list-image.category_id > p').on('click', '.ws-pro-list-image.category_id > p', async function (e) {
                            $('.cart_tab2 #CS-Wishlist-page').removeClass('selectCategory');
                            e.preventDefault();
                            var chooseCat = $(this).attr('data-catid');
                            var wsAdd = {};
                            wsAdd.store_name = window.wsapps.store_name;
                            wsAdd.customer_id = customer_id ? customer_id : ajaxcustomer_id;
                            wsAdd.customer_email = customer_email ? customer_email : ajaxcustomer_email;
                            wsAdd.customer_name = customer_name ? customer_name : ajaxcustomer_name;

                            if (chooseCat) {
                                wsAdd.category_id = chooseCat;
                            } else if (latestCategories) {
                                wsAdd.category_id = latestCategories;
                            }
                            wsAdd.product_id = data_id ? data_id : window.wsapps.product_id;
                            wsAdd.variant_id = variant_id ? variant_id : window.wsapps.variant_id;
                            var requestOptions = {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(wsAdd)
                            };
                            fetch('https://wishlistapp.manieredevoir.com/api/add-to-wishlist', requestOptions)
                                .then(function (response) {
                                    if (!response.ok) {
                                        throw new Error('Network response was not ok.');
                                    }
                                    return response.json();
                                })
                                .then(async function (result) {
                                    
                                    var addpendHTML = '';
                                    var apiUrl = `/products/${productHandle}?view=ws-pro-list`;        
                                    try {
                                      const response = await fetch(apiUrl);
                                      if (response.ok) {
                                        const htmlText = await response.text();
                                        const tempDiv = document.createElement('div');
                                        tempDiv.innerHTML = htmlText;
                                        if (tempDiv.querySelector('.cross-sell-product-item')) {
                                          addpendHTML += htmlText;
                                        }
                                      } else {
                                        //console.error(`Failed to fetch for product ${product.handle}: ${response.status}`);
                                      }
                                    } catch (error) {
                                      console.error('Error fetching data:', error);          
                                    }
                                    $('.productHandlesByCategory-' + wsAdd.category_id).find('.scroll_product_drawer').each(function() {
                                      $('.productHandlesByCategory-' + wsAdd.category_id).removeClass('is-empty');
                                      if(addpendHTML){
                                        $(this).children().eq(0).after(`<div class="ws-pro-list-image 123">${addpendHTML}</div>`);
                                      }
                                    });
                                    document.querySelector(`.productHandlesByCategory.productHandlesByCategory-${wsAdd.category_id}`).scrollIntoView();
                                    // this function remove beacuse of when added wislist in product and add to cart without side drawer close then it will not proper work
                                    CSWishlistrefreshData();
                                    
                                })
                                .catch(function (error) {
                                    console.error('error', error);
                                });

                        })
                    } else {
                        btnClick(target, productHandle, data_id, variant_id, category_id, null, customer_id, customer_name, customer_email)
                    }
                } else {
                    btnClick(target, productHandle, data_id, variant_id, category_id, null, customer_id, customer_name, customer_email)
                }

            })
            .catch(error => {
                console.error('Error:', error);
            });
      }
  }


  async function btnClick(target, productHandle, data_id, variant_id, category_id, remove, customer_id, customer_name, customer_email) {  
    //console.log('btnClick ====================================================== API');    
    var button = target.querySelector('#ws-fav-btn');
    if (button.classList.contains('ws-active')) {
        var wsRemove = {};
        wsRemove.store_name = window.wsapps.store_name;
        wsRemove.product_id = data_id ? data_id : window.wsapps.product_id;
        wsRemove.category_id = category_id;        
        var requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(wsRemove)
        };
        
        //console.log('wsRemove ===', wsRemove);
        fetch('https://wishlistapp.manieredevoir.com/api/remove-from-wishlist', requestOptions)
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok.');
                }
                return response.json();
            })
            .then(function(result) {
                console.log("result ===", result);
                if(productHandle){            
                    if(remove){
                        if(listId){
                            let items = $('.page-width #CS-Wishlist-page .cross-sell-product-item').not('.delete_hide');                            
                            if(items.length == 0){                      
                                CSCategoryGetSingle(category_id)
                            }
                            if(document.querySelector('.min-cart').classList.contains('active') && fromUserId){                                
                              CSCategoryGetSingle(category_id);
                            }else{
                              //console.log('6 =================');
                              CSRetrieveWishlistData('drawer');
                            }
                        }else{
                            let cartTabLengths = [];
                            let pageWidthLengths = [];
                            $('.cart_tab2 .productHandlesByCategory').each(function() {
                                let items = $(this).find('.ws-pro-list-image').not('.delete_hide').not('.category_id');              
                                cartTabLengths.push(items.length);
                                if(items.length == 0){ 
                                    $(this).addClass('is-empty');
                                }
                            });
                            
                            if(!fromUserId){
                              $('.page-width .productHandlesByCategory').each(function() {
                                  let items = $(this).find('.ws-pro-list-image').not('.delete_hide').not('.category_id');                                
                                  pageWidthLengths.push(items.length); // Store the length in the array
                                  if (items.length == 0) { 
                                      $(this).addClass('is-empty');
                                      $(this).find('.view_all_link').hide();
                                  }
                              });                              
                              // Compare the lengths after both loops                            
                              for (let i = 0; i < cartTabLengths.length; i++) {
                                  if (cartTabLengths[i] !== pageWidthLengths[i]) {
                                      if(pageWidthLengths[i] == 0 && cartTabLengths[i] > pageWidthLengths[i]){  
                                        //console.log('7 =================');
                                        CSRetrieveWishlistData();                                      
                                      }                                   
                                  }
                              }
                            }
                                                        
                            if(location.pathname.includes(pageUrl) && document.querySelector('.min-cart').classList.contains('active')){
                              //console.log('8 =================');
                              CSRetrieveWishlistData();
                            }else if(location.pathname.includes(pageUrl)){
                              //console.log('9 =================');
                              CSRetrieveWishlistData('drawer');
                            }  
                        }                        
                        if((!document.querySelector('.min-cart').classList.contains('active') && location.pathname.includes('/collections/')) || 
                          (!document.querySelector('.min-cart').classList.contains('active') && location.pathname.includes('/products/'))){
                          //console.log('10 =================');
                          CSRetrieveWishlistData('drawer');
                        }
                    }else{
                        setLoader();
                        CSUpdateUI(button)  
                    }
                }else{              
                    CSUpdateUI(button, 'buttonPDP')
                }
            })
            .catch(function(error) {
                console.log('error', error);
            });            
    } else {        
        var wsAdd = {};
        wsAdd.store_name = window.wsapps.store_name;      
        wsAdd.customer_id = customer_id ? customer_id : ajaxcustomer_id;
        wsAdd.customer_email = customer_email ? customer_email : ajaxcustomer_email;
        wsAdd.customer_name = customer_name ? customer_name : ajaxcustomer_name;
        //console.log('wsAdd btnClick ===', wsAdd)
        if (category_id){
            wsAdd.category_id = category_id;
        } else if(latestCategories){
            wsAdd.category_id = latestCategories;
        }
        wsAdd.product_id = data_id ? data_id : window.wsapps.product_id;
        wsAdd.variant_id = variant_id ? variant_id : window.wsapps.variant_id;
        var requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(wsAdd)
        };
        try {
            const response = await fetch('https://wishlistapp.manieredevoir.com/api/add-to-wishlist', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const result = await response.json();
            if(category_id){
                $('.cart_tab2 #CS-Wishlist-page').removeClass('selectCategory');
            }          
            $('.header .cart a, .cart_tab_link2').trigger('click');
            var addpendHTML = await getproHTML(`/products/${productHandle}?view=ws-pro-list`);            
            if($('.productHandlesByCategory-' + wsAdd.category_id).length > 0){
              $('.productHandlesByCategory-' + wsAdd.category_id).find('.scroll_product_drawer').append(`<div class="ws-pro-list-image">${addpendHTML}</div>`);
            }else{              
              $('.productHandlesByCategory[data-name="FAVOURITE"]').find('.scroll_product_drawer').append(`<div class="ws-pro-list-image">${addpendHTML}</div>`);
            }
            target.querySelector('#ws-fav-btn').classList.add('ws-active');
            target.querySelector('.cs-wishlist-icon').innerHTML = fillicon;
        } catch (error) {
            console.log('error', error);
        }
    }
  }
  
  async function getproHTML(file) {
      let x = await fetch(file);
      let y = await x.text();
      return y;
  }

  function btnClickAfterPopup(target, productHandle, data_id, variant_id, categary_id, customer_id, customer_name, customer_email) {  
    //console.log('btnClickAfterPopup ====================================================== API');
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = customer_id ? customer_id : ajaxcustomer_id;    
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;  
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {
      
      if (result && typeof result.data === 'object' && result.data !== null && Array.isArray(result.data.categories)) {
        var mainArray = result.data.categories; 
        if (Array.isArray(mainArray) && mainArray.length > 0) {
          latestCategories = mainArray[mainArray.length - 1].id;          
        }
      }
    
    
      var wsAdd = {};
      wsAdd.store_name = window.wsapps.store_name;    
      wsAdd.customer_id = customer_id ? customer_id : ajaxcustomer_id;
      wsAdd.customer_email = customer_name ? customer_name: ajaxcustomer_email;
      wsAdd.customer_name = customer_email ? customer_email: ajaxcustomer_name;      
      if(latestCategories){
        wsAdd.category_id = latestCategories;
      }
      wsAdd.product_id = data_id ? data_id : window.wsapps.product_id;
      wsAdd.variant_id = variant_id ? variant_id : window.wsapps.variant_id;    
      
      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wsAdd)
      };
      fetch('https://wishlistapp.manieredevoir.com/api/add-to-wishlist', requestOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then(function(result) {
          location.reload(true);
        })
        .catch(function(error) {
          console.log('error', error);
      });
    })
  }



  function CSWSPageDataHeader(isNot) {
    // console.log('CSWSPageDataHeader ======================================================');
    var customerId = window.wsapps && ajaxcustomer_id ? `data-cusID="${ajaxcustomer_id}"` : `onclick="location.href = '/account';"`;
    var CSWSPageDataHeader = `
    <div id="cs-page-header">
      <div class="csws-header">
        <div class="csws-header-title">
          <div class="button_back"><a href="/"></a><h4 class="csws-header-uname">`+ajaxcustomer_name+` Wishlist</h4></div>
        </div>
      </div>
      `;
    
    CSWSPageDataHeader += `</div>`;
    return CSWSPageDataHeader;
  }
  function emptyhtmlGrid(params) {
    //console.log('emptyhtmlGrid ======================================================');    
    var emptyhtml = `<div class="cs-wishlist-wrapper"><div class="productHandlesByCategory is-empty" data-name="FAVOURITE">`;
    emptyhtml += CSWSPageDataInnerHeader('FAVOURITE', null, 'empty_create', null, true);
    emptyhtml += `<ul class="${window.wsapps.parentClass}"></ul>`;    
    emptyhtml += removeContent();
    emptyhtml += `</div></div>`;
    return emptyhtml;
  }

  function CSWSPageDataInnerHeader(key, id, new_create, hasProduct, isNot, element){   
    // console.log('CSWSPageDataInnerHeader ====================================================== Disha 2', key);    
    var cs_cate_title = ''
    if(key){
      cs_cate_title = key;
    }else{
      cs_cate_title = '<input class="cs-new-list-title" id="cs-new-list-title" type="text" placeholder="Enter List Name"  required="required" maxlength="40">'      
      var createListButtons = document.querySelectorAll("#csws-create-list");
      if (createListButtons.length > 0) {
        createListButtons.forEach(function(button) {
          button.setAttribute('disabled', 'disabled');
        });
      }
    }
    var CSWSPageDataInnerHeaderInfo = `<div class="cs-list-header-title"><h4>`+cs_cate_title.toLowerCase()+`</h4>
      <div class="cs-dropdown cs-dropdown-options 0000">
          <button class="cs-dropdown-toggle" id="cs-dropdown-toggle">
              `+window.wsapps.dots+`
          </button>
          <ul class="cs-dropdown-menu-main" role="menu">
              ${new_create === 'new_create' || new_create === 'empty_create' && !isNot ? `` : `<li class="cs-dropdown-menu-action">
                <button class="cs-dropdown-menu-btn category-edit" aria-label="Rename" data-val="${id}">Rename</button>
            </li>`}
              ${isNot ? `` : `<li class="cs-dropdown-menu">
                  <button class="cs-dropdown-menu-btn category-destroy" aria-label="Delete" data-val="${id}">Delete</button>
              </li>`}
          </ul>
        </div>
      </div>`;
    if(new_create){      
      if(element){
        var csWishlistWrappers = document.querySelectorAll('.cart_tab2 .cs-wishlist-wrapper');  
      }else{
        var csWishlistWrappers = document.querySelectorAll('.main-wrapper .cs-wishlist-wrapper');  
      }
      csWishlistWrappers.forEach(function(csWishlistWrapper) {
        var newDiv = document.createElement('div');
        newDiv.className = 'productHandlesByCategory ';
        newDiv.setAttribute('data-name', 'newCategory');
        newDiv.innerHTML = CSWSPageDataInnerHeaderInfo + `<ul class="${window.wsapps.parentClass}"></ul>` + removeContent();
        csWishlistWrapper.insertAdjacentElement('afterbegin', newDiv);
      });      
    }
    return CSWSPageDataInnerHeaderInfo;
  }


  function removeContent() {
    //console.log('removeContent ======================================================');
    var removeContent = `<div class="cs-list-delete-modal" style="display: none;">
              <div class="cs-delete-title">Delete this list?</div>
              <div class="cs-delete-btn">
                  <button class="cs-btn-cancel">Cancel</button>
                  <button class="cs-btn-delete">Delete</button>
              </div>
          </div>`;
    return removeContent;
  }

  
  // Set Page Wishlist
  function CSWishlistPageData(result, productList){   
    //console.log('CSWishlistPageData ====================================================== Disha 1');    
    var wishlists = result.data.categories;
    if (Array.isArray(wishlists) && wishlists.length){      
      var html = CSWSPageDataHeader(true);
    }else{
      var html = CSWSPageDataHeader();
      html += emptyhtmlGrid();
    }
    // $('.cs-wishlist-wrapper').remove();
    if(wishlists.length > 0) {
      html += `<div class="cs-wishlist-wrapper">`;
      wishlists.slice().reverse().forEach(category => {
        var hasProduct = false;
        if(category.products.length == 0){
          hasProduct = true;
        }
        html += `<div class="dropzone productHandlesByCategory productHandlesByCategory-${category.id} category-id-${category.category_name} ${category.products.length == 0 ? 'is-empty' : ''}" data-name="${category.category_name}" id="category-id-${category.category_name.replace(/\s/g, '')}" data-cat-id="${category.id}">`;
        html += CSWSPageDataInnerHeader(category.category_name, category.id, hasProduct);
        html += `<div class="${window.wsapps.parentClass}">`;
        // Create category title
        const title = document.createElement('h2');
        title.textContent = category.category_name;
        // Create a list for products
        category.products.slice().reverse().slice(0, 6).forEach(product => {
          html += `
          <div draggable="true" data-pro-id="${product.shopify_product_id}" data-varId="${product.variants.shopify_variant_id}" class="ws-pro-list-image main-product-item" data-handle="${product.handle}">
            <div class="main-product-wrp">
              <a href="/pages/${window.wsapps.pageURL}?from_user_id=${ajaxcustomer_id}&list_id=${category.id}" data-href="${product.image_url}" class="main-product-inner" draggable="false"> 
                <img src="${product.image_url}" alt="${product.title}" loading="lazy" data-pro-name="${product.title}" />
              </a>
              <div class="cs_ws_icon" data-id="${product.shopify_product_id}" data-handle="${product.handle}" data-varId="${product.shopify_product_id}">
                <button aria-label="Add to Wishlist" id="ws-fav-btn" type="button" class="action_button  ws-active"><span class="cs-wishlist-icon"><svg width="25" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5801 0.992188L14.668 7.2511L21.5801 8.2606L16.5801 13.13L17.7678 20.0183L11.5801 16.7642L5.39243 20.0183L6.58008 13.13L1.58008 8.2606L8.49219 7.2511L11.5801 0.992188Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></button>
              </div>
            </div>  
          </div>`
        });
        html += `</div>`;
        html += `<div class="view_all_link"><a href="/pages/${window.wsapps.pageURL}?from_user_id=${ajaxcustomer_id}&list_id=${category.id}" data-catId="${category.id}">View All</a></div>`;
        html += removeContent();
        html += `</div>`;
      });
      html += `</div>`;
    }
    html += `<div class="sign-out create-list-btn link_btn"><button title="Add a new list" id="csws-create-list" class="btn csws-list csws-action" data-event="click" data-action="createList" ${ajaxcustomer_id}>Add list</button></div>`;
    html += `<div class="sign-out link_btn"><a href='/account/logout'>Log out</a></div>`;
    var wishlistHTML = document.querySelectorAll('.main-wrapper .CS-Wishlist-page');
    if(wishlistHTML.length > 0){
      for (var i = 0; i < wishlistHTML.length; i++) {
        wishlistHTML[i].classList.add("wishlist-overflow");
        wishlistHTML[i].innerHTML = '';  
        wishlistHTML[i].innerHTML += html;
      }
    }
  } 

  // Set Page Drawer Data
  function CSWishlistDrawerData(result, productList){   
    //console.log('CSWishlistDrawerData ====================================================== Disha 2');
    var wishlists = result.data.categories;
    if (Array.isArray(wishlists) && wishlists.length){      
      var html = CSWSPageDataHeader(true);
    }else{
      
      var html = CSWSPageDataHeader();
      html += emptyhtmlGrid();
    }
    
    // $('.cs-wishlist-wrapper').remove();
    if(wishlists.length > 0) {
      html += `<div class="cs-wishlist-wrapper">`;
      wishlists.slice().reverse().forEach(category => {
        var hasProduct = false;
        if(category.products.length == 0){
          hasProduct = true;
        }
        html += `<div class="productHandlesByCategory productHandlesByCategory-${category.id} category-id-${category.category_name} ${category.products.length == 0 ? 'is-empty' : ''}" data-name="${category.category_name}" id="category-id-${category.category_name.replace(/\s/g, '')}" data-cat-id="${category.id}">`;
        html += CSWSPageDataInnerHeader(category.category_name, category.id, null, hasProduct, null, 'CS-drawer-wishlist');
        html += `<div class="${window.wsapps.parentClass}"><div class="ws-pro-list-image category_id" ><p data-catID="${category.id}">Add to Wishlist</p></div>`;
        // Create category title
        const title = document.createElement('h2');
        title.textContent = category.category_name;
        
        // Create a list for products
        category.products.slice().reverse().forEach((product, index) => {          
          html += `
          <div class="ws-pro-list-image ${product.handle}" data-loop="${index}">
            <div class="cross-sell-product-item-page cross-sell-product-item cross-sell-item main-product-item two_column_item" data-handle="${product.handle}" data-id="${product.shopify_product_id}">
              <div class="cross-sell-product-image">
                <a href="/products/${product.handle}">
                  <img src="${product.image_url}}" alt="${product.title}" loading="lazy">
                </a>
              </div>
              <div class="cross-sell-product-content">
                <div class="cross-sell-product-price">      
                  <div class="cs-product-title">
                    <a href="/pages/${product.handle}">${product.title}</a>
                  </div>
                  <div class="cs_ws_icon" data-id="${product.shopify_product_id}" data-handle="${product.handle}" data-varId="${product.shopify_product_id}">
                    <button aria-label="Add to Wishlist" id="ws-fav-btn" type="button" class="action_button  ws-active"><span class="cs-wishlist-icon"><svg width="25" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5801 0.992188L14.668 7.2511L21.5801 8.2606L16.5801 13.13L17.7678 20.0183L11.5801 16.7642L5.39243 20.0183L6.58008 13.13L1.58008 8.2606L8.49219 7.2511L11.5801 0.992188Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></button>
                  </div>                  
                </div>
              </div>
            </div>
          </div>`
        });
        html += `</div>`;
        if(category.products.length > 0){
          html += `<div class="view_all_link"><a href="/pages/${window.wsapps.pageURL}?from_user_id=${ajaxcustomer_id}&list_id=${category.id}" data-catId="${category.id}">View All</a></div>`;
        }
        html += removeContent();
        html += `</div>`;
      });
      html += `</div>`;
    }
    html += `<div class="sign-out create-list-btn link_btn"><button title="Add a new list" id="csws-create-list" class="btn csws-list csws-action" data-event="click" data-action="createList" ${ajaxcustomer_id}>Add list</button></div>`;    
    html += `<div class="sign-out link_btn"><a href='/account/logout'>Log out</a></div>`; 
    
    var wishlistHTML = document.querySelectorAll('.CS-drawer-wishlist');
    $('.productHandlesByCategory[data-name="newCategory"]:not(.is-empty)').remove();
    if(wishlistHTML.length > 0){
      for (var i = 0; i < wishlistHTML.length; i++) {
        wishlistHTML[i].classList.add("wishlist-overflow");
        wishlistHTML[i].innerHTML = '';  
        wishlistHTML[i].innerHTML += html;
      }
    }  
    if(location.pathname.includes('/collections/')){ 
      wishlistBtnCollection(productList); 
    }
    if(location.pathname.includes('/products/')){ 
      wishlistBtnPDP(productList);
    }
    formData();
  } 

  async function formData() {
    //console.log('formData ======================================================')
    document.querySelectorAll('.cross-sell-product-item').forEach(async (item) => {      
      var productHandle = item.getAttribute('data-handle');
      if(productHandle){
        var addpendHTML = await getproHTML(`/products/${productHandle}?view=ws-pro-list-new`);
        
        const html = addpendHTML;
        if (!html.trim() || html.includes('404') || html.includes('Page Not Found')) {
          $('.productHandlesByCategory .cross-sell-product-item-drawer[data-handle="'+ productHandle +'"]').hide();
          $('.ws-pro-list-image.main-product-item[data-handle="'+ productHandle +'"]').hide();
          $('.ws-pro-list-image.'+productHandle).hide()
          return '';
        }else {
          let el = item.querySelector('#product_add');
          if (el) { el.remove(); }
          let el2 = item.querySelector('.cross-sell-product-price.fetch-template');
          if (el2) { el2.remove(); }          
          item.querySelector('.cross-sell-product-price').insertAdjacentHTML('afterend', addpendHTML);
        }
      }
    });
  }
  
  document.addEventListener("click", function(e){ 
    document.querySelectorAll('.cs-dropdown-menu-main, .cs-dropdown-menu-mai').forEach((item) => {
      item.classList.remove('active');  
    })
    // Show toggle
    var csDropdownToggle = e.target.closest('.cs-dropdown-toggle'); // Or any other selector.    
    if(csDropdownToggle){
      var dropdownMenu = csDropdownToggle.parentElement.querySelector('.cs-dropdown-menu-main');
      if (dropdownMenu) {
        dropdownMenu.classList.toggle('active');
      }
    }


    // Click Category Destroy 
    // var categoryDestroyButtons = e.target.closest(".category-destroy");
    // if(categoryDestroyButtons){      
    //   categoryDestroyButtons.closest('.productHandlesByCategory').querySelector('.product-grid').style.display = 'none';     
    //   categoryDestroyButtons.closest('.productHandlesByCategory').querySelector('.cs-list-delete-modal').style.display = 'block';
      
    // }
    
    // // Click Cancel Btn
    // var categoryDestroyCancelButtons = e.target.closest('.cs-btn-cancel');
    // if(categoryDestroyCancelButtons){      
    //   categoryDestroyCancelButtons.closest('.productHandlesByCategory').querySelector('.cs-list-delete-modal').style.display = 'none';
    //   categoryDestroyCancelButtons.closest('.productHandlesByCategory').querySelector('.product-grid').style.display = 'flex';
    // }

    // Click Delete Btn 
    var categoryDestroyDeleteButtons = e.target.closest('.category-destroy');
    if(categoryDestroyDeleteButtons){    
      var closestProductHandles = categoryDestroyDeleteButtons.closest('.productHandlesByCategory');        
      var dataCategoryID = closestProductHandles.getAttribute('data-cat-id');
      removeCategory(dataCategoryID)
    }

    // Click Category Edit
    // var categoryEditButtons = e.target.closest('.category-edit');
    // if(categoryEditButtons){      
    //   var closestProductHandles = categoryEditButtons.closest('.productHandlesByCategory');        
    //   if (closestProductHandles) {
    //     var dataCategoryName = closestProductHandles.getAttribute('data-name');
    //     var dataCategoryID = closestProductHandles.getAttribute('data-cat-id');
    //     var cs_cate_title = '<input class="cs-edit-list-title" id="cs-edit-list-title" type="text" placeholder="List name"  required="required" maxlength="40" data-cat-id="'+dataCategoryID+'" value="'+dataCategoryName+'">';
    //     closestProductHandles.querySelector('h2').innerHTML = cs_cate_title;    
        
    //   }
    // }
    // var csEditListTitle = e.target.closest('#cs-edit-list-title');
    // if(csEditListTitle){        
    //   var dataCategoryID = csEditListTitle.getAttribute('data-cat-id');
    //   csEditListTitle.addEventListener('blur', function(event) {       
    //     dataCategoryID !== 'null' ? updateCategoryName(event.target.value, dataCategoryID) : createCategory(event.target.value);
    //   });
    // }
    var categoryEditButtons = e.target.closest('.category-edit');
    if (categoryEditButtons) {
      var closestProductHandles = categoryEditButtons.closest('.productHandlesByCategory');
      if (closestProductHandles) {
        var dataCategoryName = closestProductHandles.getAttribute('data-name');
        var dataCategoryID = closestProductHandles.getAttribute('data-cat-id');
        var cs_cate_title = '<input class="cs-edit-list-title" id="cs-edit-list-title" type="text" placeholder="List name" required="required" maxlength="40" data-cat-id="' + dataCategoryID + '" value="' + dataCategoryName.toLowerCase() + '">';
        closestProductHandles.querySelector('h4').innerHTML = cs_cate_title;
    
        var inputElement = closestProductHandles.querySelector('.cs-edit-list-title');
        inputElement.focus();
    
        // Move cursor to the end of the input value
        inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
    
        inputElement.addEventListener('blur', function(event) {
          event.preventDefault(); // Prevent default behavior of Enter or Tab          
          dataCategoryID !== 'null' ? updateCategoryName(inputElement.value, dataCategoryID) : createCategory(inputElement.value);          
        });
      }
    }


    
    // Hide productHandlesByCategory content
    var listHeaderDropdowns  = e.target.closest('.list-header-dropdown'); // Or any other selector.    
    if (listHeaderDropdowns) {
      var closestProductHandles = listHeaderDropdowns.closest('.productHandlesByCategory');
      if (closestProductHandles) {
        closestProductHandles.classList.toggle('productHandlesByCategory_hide');
      }
    }
      


    // Add in Wishlist Collection and Product page
    var target = e.target.closest('#'+wsBtnID) || e.target.closest(addToWishlistCollection) ; // Or any other selector.    
    if (target) {
      var abcParentDiv = target.closest('.CS-Wishlist-page');
      var productHandle = target.getAttribute('data-handle'); 
      var data_id = target.getAttribute('data-id'); 
      var variant_id = target.getAttribute('data-varId'); 
      var category_id = target.getAttribute('data-categoryId');
      var parentElement = target.parentElement;
      var productElement = target.closest('.productHandlesByCategory');      
      if (productElement &&  productElement.getAttribute('data-cat-id')) {
        category_id = productElement.getAttribute('data-cat-id');        
      }
      if(ajaxcustomer_id){
        if (abcParentDiv) { 
          target.closest('.cross-sell-product-item') ? e.target.closest('.cross-sell-product-item').classList.add("delete_hide") : '';
          target.closest('.ws-pro-list-image') ? e.target.closest('.ws-pro-list-image').remove() : '';
          btnClick(target, productHandle, data_id, variant_id, category_id, 'remove');
        }else{
          if (target.querySelector('#ws-fav-btn').classList.contains('ws-active')) {
            btnClick(target, productHandle, data_id, variant_id, category_id, 'remove');
            target.querySelector('#ws-fav-btn').classList.remove('ws-active');
            target.querySelector('.cs-wishlist-icon').innerHTML = icon;
          } else {
            categoryGetList(target, productHandle, data_id, variant_id, category_id)
          }
        }
      }else{
        var wishlistPopup = document.querySelector('body > .wishlist-popup');
        if (wishlistPopup) {
          wishlistPopup.classList.add('active');     
          loginPopupFunction(target, productHandle, data_id, variant_id, category_id)
          registerPopupFunction(target, productHandle, data_id, variant_id, category_id)
          
        }
      }
    }
    //Click on Add a new list


    // Select all elements with the ID 'csws-create-list'
    var csCreateLists = document.querySelectorAll('#csws-create-list');
    var csCreateList = Array.from(csCreateLists).find(element => element.contains(e.target));

    if (csCreateList) {
      if ($('.min-cart').hasClass('active')) {
        $('.cs-wishlist-wrapper').animate({
          scrollTop: 0
        }, 2000);
        $('.cs-wishlist-wrapper').css('overflow', 'hidden');
        CSWSPageDataInnerHeader(null, null, 'new_create', null, null, 'Drawer');
      } else{
        $('html, body').animate({
          scrollTop: $(".page-width #CS-Wishlist-page").offset().top
        }, 500);
        CSWSPageDataInnerHeader(null, null, 'new_create');
      }
      //console.log('===============================================================');
    }

    // var csNewListTitle = e.target.closest('#cs-new-list-title'); 
    // if(csNewListTitle){
    //   csNewListTitle.addEventListener('blur', function(event) {          
    //     var inputValue = event.target.value.trim();
    //     if (inputValue !== '') {
    //       //console.log('createCategory ============================= 2');
    //       createCategory(event.target.value)
    //     }else{
    //       event.target.value = '';
    //       CSUpdateUI(null, null, 'newCreate');
    //     }        
    //   });
    // }
  });


  document.addEventListener('focusout', function(event) {
    const target = event.target;
    if (target && target.id === 'cs-new-list-title') {
      const inputValue = target.value.trim();
      if (inputValue !== '') {
        createCategory(inputValue);
      } else {
        target.value = '';
        CSUpdateUI(null, null, 'newCreate');
      }
    }
  });

  
  
// Change Category Product
  function changeCategoryPro(category_id, product_id, variant_id){
    var wsAdd = {};
    wsAdd.store_name = window.wsapps.store_name;
    wsAdd.customer_id = ajaxcustomer_id;
    wsAdd.customer_name = ajaxcustomer_name;
    wsAdd.customer_email = ajaxcustomer_email;
    wsAdd.category_id = category_id,
    wsAdd.product_id = product_id;
    wsAdd.variant_id = variant_id;
    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(wsAdd)
    };
    fetch('https://wishlistapp.manieredevoir.com/api/add-to-wishlist', requestOptions)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
        return response.json();
      })
      .then(function(result) {        
      })
      .catch(function(error) {
        console.log('error', error);
    });
  }
  
  // Category Destroy Function
  function removeCategory(dataCategoryID){   
    //console.log('removeCategory ====================================================== API', dataCategoryID);
    //console.log('dataCategoryID ===', dataCategoryID)
    if(dataCategoryID){
      var wsRemove = {};
      wsRemove.store_name = window.wsapps.store_name;    
      var requestOptions = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wsRemove)
      };       
      fetch('https://wishlistapp.manieredevoir.com/api/category/'+dataCategoryID, requestOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then(function(result) {
          var elementsToRemove = document.querySelectorAll('.productHandlesByCategory-' + dataCategoryID);
          elementsToRemove.forEach(function(element) {
            element.parentNode.removeChild(element);
          });

          var CSWishlistPage = document.getElementById("CS-Wishlist-page");
          if(CSWishlistPage){
            CSWishlistPage.innerHTML = '<div class="EmptyPageData"><img src="https://cdn.shopify.com/s/files/1/0282/6678/files/Eiffel-Simultaneous.gif?v=1689851940" /></div>';
          }
          
          CSUpdateUI(null, null, 'newCreate')
        })
        .catch(function(error) {
          console.log('error', error);
      });
    }else{
      document.getElementById("csws-create-list").removeAttribute('disabled', 'disabled');
      var productHandles = document.querySelector('.productHandlesByCategory.is-empty[data-name="newCategory"]');      
      if (productHandles) {
          productHandles.style.display = 'none';
      }      
    }
  }

  // Update categories Name
  function updateCategoryName(createCategoryName, createCategoryId){
    //console.log('updateCategoryName ====================================================== API');
    if(createCategoryName && createCategoryId ){
      var wsAdd = {};
      wsAdd.store_name = window.wsapps.store_name;        
      wsAdd.category_name = createCategoryName;
      var requestOptions = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wsAdd)
      }; 
      fetch('https://wishlistapp.manieredevoir.com/api/category/'+createCategoryId, requestOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then(function(result) {            
          var csEditListTitle = document.getElementById('cs-edit-list-title');
          if (csEditListTitle) {
            csEditListTitle.closest('.productHandlesByCategory').classList.add('productHandlesByCategory-'+result.data.id)
            csEditListTitle.closest('.productHandlesByCategory').setAttribute('data-name', result.data.category_name);              
            csEditListTitle.closest('.productHandlesByCategory').setAttribute('data-cat-id', result.data.id);              
            csEditListTitle.closest('h4').innerHTML = result.data.category_name;
          } 
          setLoader();
          CSUpdateUI(null, null, 'newCreate');
        })
        .catch(function(error) {
          console.log('error', error);
      });
    }
  }
  
  // Create new categories 
  function createCategory(createCategoryName){
    //console.log('createCategory ====================================================== API');
    if(createCategoryName){
      var wsAdd = {};
      wsAdd.store_name = window.wsapps.store_name;      
      wsAdd.customer_id = ajaxcustomer_id;
      wsAdd.category_name = createCategoryName;
      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wsAdd)
      };        
      fetch('https://wishlistapp.manieredevoir.com/api/category', requestOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then(function(result) {
          var csEditListTitle = document.getElementById('cs-new-list-title');
          if (csEditListTitle) {
            csEditListTitle.closest('.productHandlesByCategory').classList.add('productHandlesByCategory-'+result.data.id)
            csEditListTitle.closest('.productHandlesByCategory').setAttribute('data-name', result.data.category_name);              
            csEditListTitle.closest('.productHandlesByCategory').setAttribute('data-cat-id', result.data.id);              
            csEditListTitle.closest('h4').innerHTML = result.data.category_name;
          }
          var createListButtons = document.querySelectorAll("#csws-create-list");
          if (createListButtons.length > 0) {
            createListButtons.forEach(function(button) {
              button.removeAttribute('disabled');
            });
          }
          setLoader()          
          CSUpdateUI(null, null, 'newCreate')
        })
        .catch(function(error) {
          console.log('error', error);
      });
    }
  }





  
  // Drag functionality
  (function() {
    var dragged = null, positions = [];
    function getObject(parentId, html, index, elementID){
       let item = {
        parentId: parentId,
        html: html,
        position: index,
        currentID: elementID
      };
      return item;
    }
    document.addEventListener("dragstart", (event) => {
      return dragged = event.target;
    });

    document.addEventListener("dragend", (event) => {        
    });

    document.addEventListener("dragover", function(event) {
      return event.preventDefault();
    });

    document.addEventListener("drop", (event) => {
      event.preventDefault();
      let draggedParent = dragged.closest(".product-grid");
      if (event.target.closest('.productHandlesByCategory').classList.contains("dropzone")) {
        var getParentDiv = event.target.closest('.productHandlesByCategory').querySelector('.product-grid');
        dragged.closest(".product-grid").removeChild(dragged);
        draggedParent.children.length == 0 ? draggedParent.closest('.productHandlesByCategory').classList.add('is-empty') : draggedParent.closest('.productHandlesByCategory').classList.remove('is-empty');
        getParentDiv.appendChild(dragged);
        getParentDiv.children.length == 0 ? getParentDiv.closest('.productHandlesByCategory').classList.add('is-empty') : getParentDiv.closest('.productHandlesByCategory').classList.remove('is-empty');          
        var dataProId = dragged.getAttribute('data-pro-id');
        var dataProVarId = dragged.getAttribute('data-varid');
        var dataCatId = event.target.closest(".productHandlesByCategory").getAttribute('data-cat-id');    
        changeCategoryPro(dataCatId, dataProId, dataProVarId);
      }
    });    
  }).call(this);


  // Login form submission
  var formSubmitting = false;
  function loginPopupFunction(target, productHandle, data_id, variant_id, category_id) {
    //console.log('loginPopupFunction ======================================================');
    $('body > .wishlist-popup #main-login-drawer.wishlist-popup-form > #customer_login').off('submit').on("submit", function(e) {      
      $('div#main-login-drawer .error_info').remove();
      e.preventDefault();      
      if (!formSubmitting) {          
        $.ajax({
          url: '/account/login',
          method: 'post',
          data: $(this).serialize(),
          dataType: 'html',
          async: true,
        }).done(function(response){
          if(response.indexOf('Incorrect email or password.') !== -1){
            $('div#main-login-drawer').prepend('<p class="error_info text-unset">Incorrect Email or Password.</p>');   
            formSubmitting = false;
          }else{
            formSubmitting = true;
            if(variant_id){          
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = response;
              var customer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
              ajaxcustomer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
              
              var customer_name = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerName');
              ajaxcustomer_name = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerName');
              
              var customer_email = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customeremailId');
              ajaxcustomer_email = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customeremailId');

              console.log('11 =================');
              CSRetrieveWishlistData('drawer', customer_id, customer_name)
              categoryGetList(target, productHandle, data_id, variant_id, category_id, customer_id, customer_name, customer_email)              
            }else{
              location.reload(true);
            }
            $('.wishlist-popup').removeClass('active');    
          }
        });
      }
    });
  }


  $('.cart_tab2 > .wishlist-popup #main-login-drawer.wishlist-popup-form > #customer_login, body.template-main-cs-wishlist .main-wrapper #tab1 > #customer_login').on( "submit", function( e ) {    
    $('div#main-login-drawer .error_info').remove();    
    e.preventDefault();    
    $.ajax({
      url: '/account/login',
      method: 'post',
      data: $(this).serialize(),
      dataType: 'html',
      async: true,
    }).done(function(response){
      $('.error_info').remove();
      if(response.indexOf('Incorrect email or password.') !== -1){
        $('div#main-login-drawer, body.template-main-cs-wishlist .main-wrapper #tab1').prepend('<p class="error_info text-unset">Incorrect Email or Password.</p>');       
      }else{
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = response;
        var customer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
        ajaxcustomer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
        ajaxcustomer_name = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerName');
        ajaxcustomer_email = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customeremailId');
        //console.log('12 =================');
        CSRetrieveWishlistData('drawer', customer_id);
        document.querySelector('.wishlist-popup').classList.remove('active');
        document.querySelector('.cart_tab2 #CS-Wishlist-page').style.display = 'flex';
        if(location.pathname.includes(pageUrl)){
          location.reload(true);
        }
      }
    });
  });


  // Registration form submission
  var registerFormSubmitting = false;
  function registerPopupFunction(target, productHandle, data_id, variant_id, category_id) {
    //console.log('registerPopupFunction ======================================================');    
    $('body > .wishlist-popup #register_form.wishlist-popup-form > #create_customer_model').on( "submit", function( e ) {
      $('div#register_form .error_info').remove();
      e.preventDefault();  
       if (!registerFormSubmitting) { 
        $.ajax({
          url: '/account',
          method: 'post',
          data: $(this).serialize(),
          dataType: 'html',
          async: true,
        }).done(function(response){  
          registerFormSubmitting = false;
          if(response.indexOf('Email is invalid') !== -1 || response.indexOf('Email can&#39;t be blank') !== -1 || response.indexOf('Password can&#39;t be blank.') !== -1 ){      
            $('div#register_form').prepend('<ul class="error_info"><li>Password can&#39;t be blank.</li><li>Email can&#39;t be blank.</li></ul>');    
          }else if(response.indexOf('Email is invalid') !== -1 ){      
            $('div#register_form').prepend('<p class="error_info text-unset">Incorrect Email or Password.</p>');       
          } else if(response.indexOf('This email address is already associated with an account. If this account is yours, you can') !== -1){
            $('div#register_form').prepend('<p class="error_info">This email address is already associated with an account. If this account is yours, you can <a href="/account/login#recover">reset your password</a></p>');       
          } else{
            registerFormSubmitting = true;
            if(variant_id){          
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = response;
              var customer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
              var customer_name = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerName');
              var customer_email = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customeremailId');
              
              btnClickAfterPopup(target, productHandle, data_id, variant_id, category_id, customer_id, customer_name, customer_email);
            }else{
              location.reload(true);
            }
            $('.wishlist-popup').removeClass('active');    
          }
        });
      }
    });
  }
  
  //registerPopupFunction()
  $('.cart_tab2 > .wishlist-popup #register_form.wishlist-popup-form > #create_customer_model, body.template-main-cs-wishlist .main-wrapper #tab2 > #create_customer_model').on( "submit", function( e ) {
      $('div#register_form .error_info').remove();
      e.preventDefault();    
      $.ajax({
        url: '/account',
        method: 'post',
        data: $(this).serialize(),
        dataType: 'html',
        async: true,
      }).done(function(response){    
        //console.log('response =', response)
        $('.error_info').remove();
        if(response.indexOf('Email is invalid') !== -1 || response.indexOf('Email can&#39;t be blank') !== -1 || response.indexOf('Password can&#39;t be blank.') !== -1 ){      
          $('div#register_form, body.template-main-cs-wishlist .main-wrapper #tab2').prepend('<ul class="error_info"><li>Password can&#39;t be blank.</li><li>Email can&#39;t be blank.</li></ul>');    
        }else if(response.indexOf('Email is invalid') !== -1 ){      
          $('div#register_form, body.template-main-cs-wishlist .main-wrapper #tab2').prepend('<p class="error_info text-unset">Incorrect Email or Password.</p>');       
        } else if(response.indexOf('This email address is already associated with an account. If this account is yours, you can') !== -1){
          $('div#register_form, body.template-main-cs-wishlist .main-wrapper #tab2').prepend('<p class="error_info">This email address is already associated with an account. If this account is yours, you can <a href="/account/login#recover">reset your password</a></p>');       
        } else{
          
          location.reload(true);
          
          $('.wishlist-popup').removeClass('active');    
        }
      });
  });
    
  
}
/// Disha Hetre



/* --------------- Register button Click Start For Popup ---------------*/
function registerClick(registerLink, mainpopup) {
  if (registerLink) {
    registerLink.addEventListener('click', function() {      
      //console.log('registerClick ======================================================');
      var checkGenderSetValue = $('body > .wishlist-popup ul.checkGender-option li.activeFinal').text();
      $('.checkGender').find('.checkGender-value').val(checkGenderSetValue);
      if(mainpopup){
        var loginPopup = document.querySelector('body > .wishlist-popup.login');
        var registerPopup = document.querySelector('body > .wishlist-popup.register');
      }else{
        var loginPopup = document.querySelector('.wishlist-popup.login');
        var registerPopup = document.querySelector('.wishlist-popup.register');
      }
      if (loginPopup) {
        loginPopup.classList.remove('active');
      }
      if (registerPopup) {
        registerPopup.classList.add('active');
      }
    });
  } 
}
var registerLink1 = document.querySelector('.popup-register-link.register-popup#instance1');
var registerLink2 = document.querySelector('.popup-register-link.register-popup#instance2');
if(registerLink1){ registerClick(registerLink1, 'mainpopup') } 
if(registerLink2){ registerClick(registerLink2) }
/* --------------- Register button Click End For Popup ---------------*/

/* --------------- Login button Click Start For Popup ---------------*/
function loginClick(loginLink, mainpopup) { 
  if (loginLink) {
    loginLink.addEventListener('click', function() {
      //console.log('Login Click ======================================================');
      if(mainpopup){
        var loginPopup = document.querySelector('body > .wishlist-popup.login');
        var registerPopup = document.querySelector('body > .wishlist-popup.register');
      }else{
        var loginPopup = document.querySelector('.wishlist-popup.login');
        var registerPopup = document.querySelector('.wishlist-popup.register');
      }
      if (loginPopup) {
        loginPopup.classList.add('active');
      }
      if (registerPopup) {
        registerPopup.classList.remove('active');
      }
    });
  }       
}
var loginLink1 = document.querySelector('.popup-register-link.login-popup#instance1');
var loginLink2 = document.querySelector('.popup-register-link.login-popup#instance2');
if(loginLink1){ loginClick(loginLink1, 'mainpopup') } 
if(loginLink2){ loginClick(loginLink2) }
/* --------------- Login button Click End For Popup ---------------*/


function closePopup() {
  //console.log('closePopup ======================================================');
  $('body > .wishlist-popup').removeClass('active');  
  $('.wishlist-popup-form').find('form').find("input[type=email], input[type=text], input[type=password], textarea").val("");
}
$('body').on('click','.wishlist-popup-close', function(e){
  //console.log('wishlist-popup-close ======================================================');
  e.preventDefault();
  closePopup();
});
$(document).keyup(function(e) {
  if (e.keyCode == 27) { 
    closePopup();
  }
});
window.onclick = function(e) {
  if ($(e.target).hasClass('main-overlay')) {
    // console.log('closePopup ======================================================');
    closePopup();
  }
}



function CSWishlistrefreshData(drawer){  
  //console.log('CSWishlistrefreshData ======================================================');
  if(window.wsapps.wishlist_status == '1') {
    if(ajaxcustomer_id){
      if(drawer){
        //console.log('13 =================');
        CSRetrieveWishlistData('drawer');  
      }else{
        if(!(location.pathname.includes(pageUrl))){
          const element = document.querySelector('.cart_tab_link2');          
          if (location.pathname.includes('/collections/') || element && element.classList.contains('active')) {
            //console.log('14 =================');
            CSRetrieveWishlistData();
          }
        }
      }
    }else{
      if(location.pathname.includes('/products/')){ 
        wishlistBtnPDP()
      }
      if(location.pathname.includes('/collections/')){ 
        wishlistBtnCollection()
      }
      emptyPage();
    }
  }
}
$(document).ready(function(){

    $(document).on("click","#CS-Wishlist-page .cross-sell-product-item .select-option",function(e) {
      e.preventDefault();
      $('.check-stock-msg ').removeClass('active');
      $('#CS-Wishlist-page .cross-sell-product-item .variant-listbox').not($(this).parents('.variant-listbox')).removeClass("active");
      $(this).parents('.variant-listbox').toggleClass("active");
      $('#CS-Wishlist-page .cross-sell-product-item .cart-recommended-option-ul').not($(this).parents('.cross-sell-product-item').find('.cart-recommended-option-ul')).slideUp();
      if($(this).parents('.variant-listbox').hasClass("active")){
        $(this).parents('.cross-sell-product-item').find('.cart-recommended-option-ul').slideDown();
        // $(".min-cart-top").animate({ scrollTop: $('.min-cart-top').height() + $('.min-cart-main').height()}, 500);
      }else{
        $(this).parents('.cross-sell-product-item').find('.cart-recommended-option-ul').slideUp();
      }
    });

  $(document).on("click","#CS-Wishlist-page .cross-sell-product-item #variant-listbox ul li.variant-size",function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parents('.variant-listbox').removeClass("active");
    var current_variant = $(this).attr("value");
    $(this).parents("#CS-Wishlist-page .cross-sell-product-item").find("select#variant-listbox").val(current_variant).change();
    $(this).parents("#CS-Wishlist-page .cross-sell-product-item").find(".cross-sell-product-btn input").trigger("click");
    $('.cart_tab_link1').trigger('click')
  });

  $(document).on('click', function (event) {
    if (!$(event.target).closest('.variant-listbox').length) {
      $('#CS-Wishlist-page .cross-sell-product-item .variant-listbox').removeClass("active");
    }
  });
});


$(document).ready(function(){
   $('body').on('click','.cart_tab2 .productHandlesByCategory .scroll_product_drawer > div > a', function(e){
    e.preventDefault();
    var catId = $(this).attr('data-catId');    
    CSCategoryGetSingle(catId)
  })
})


